<template>
  <div>
    <v-alert
      prominent
      type="error"
      :dismissible="dismissible"
    >
      <span v-text="$t('alerts.errorOccurred')" />
    </v-alert>
    <v-expansion-panels accordion>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <span v-text="$t('labels.detail')" />
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card flat>
            <v-card-title>
              <span v-text="$t('labels.message')" />
            </v-card-title>
            <v-card-text>
              <span v-text="message" />
            </v-card-text>
            <v-card-subtitle>
              <span v-text="$t('labels.code')" />
            </v-card-subtitle>
            <v-card-text>
              <span v-text="code" />
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import { errorUtility } from '@/utils';

export default {
  name: 'BaseErrorAlert',
  props: {
    error: {
      type: Error,
      required: true,
      note: 'The error to display',
    },
    dismissible: {
      type: Boolean,
      default: false,
      note: 'Whether the alert can be dismissed',
    },
  },
  computed: {
    processedError() {
      return errorUtility.process(this.$t, this, this.error);
    },
    message() {
      return this.processedError.data.message;
    },
    code() {
      return this.processedError.status;
    },
  },
};
</script>
